import { Card, Grid, Stack, Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import AccountCheck from "page-sections/student/login/accountCheck";
import PasswordCheck from "page-sections/student/login/passwordCheck";
import skillupLogo from "assets/skillup.png";
import PositeamsLogo from "assets/positeams-logo.png";
import useSettings from "hooks/useSettings";
import { Link } from "react-router-dom";
import { Small } from "components/Typography";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import { useTranslation } from "react-i18next";

const StudentLogin = () => {
  const { t } = useTranslation();

  const [LoginIsValide, setLoginIsValide] = useState(false); // LoginIsValide is 'true' means that the user has a valid employee_id or email
  const [user, setUser] = useState(null); // user informations
  const { setThemeColor } = useSettings();

  useEffect(() => {
    if (window.location.hostname.includes("hrsurvey")) {
      setThemeColor("#e65640");
    }
  }, []);

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      sx={{
        padding: { xs: 2, sm: 3 },
      }}
    >
      <Grid item xs={12}>
        <Card sx={{ padding: 3, marginTop: 5, maxWidth: 500, mx: "auto" }}>
          <Stack gap={2} pt={2}>
            <Stack direction="row" justifyContent="center" width="100%">
              <Box
                sx={{
                  width: {
                    xs: 130,
                    sm: 180,
                  },
                }}
              >
                <Link to="/participant">
                  {window.location?.hostname?.includes("hrsurvey") ? (
                    <img
                      alt="company logo"
                      width="100%"
                      src={skillupLogo}
                    ></img>
                  ) : (
                    <img
                      alt="company logo"
                      width="100%"
                      src={PositeamsLogo}
                    ></img>
                  )}
                </Link>
              </Box>
            </Stack>

            <Box textAlign="center" mb={1}>
              <Typography variant="body1">
                Votre espace de validation des connaissances
              </Typography>
            </Box>
            {!LoginIsValide ? (
              <AccountCheck
                setLoginIsValide={setLoginIsValide}
                setUser={setUser}
              />
            ) : (
              <PasswordCheck user={user} />
            )}
          </Stack>
        </Card>
      </Grid>

      <Box mt={1}>
        <Link to="/">
          <Small>{t("Student.login.gestionnaire_login_link")}</Small>
          <KeyboardDoubleArrowRightIcon
            sx={{ fontSize: "16px", marginBottom: "-3px" }}
          />
        </Link>
      </Box>
    </Grid>
  );
};

export default StudentLogin;
